// src/work/upload.js
import api from './auth'

// 获取OSS token
export const getOssToken = () => {
  return api.get('/work/auth/oss_token')
}

// 普通上传到COS
export const uploadToCos = async (file, ossConfig, directory = 'work/') => {
  return new Promise((resolve, reject) => {
    // 这里需要使用COS SDK，需要先安装
    // npm install cos-js-sdk-v5

    const COS = require('cos-js-sdk-v5')

    const cos = new COS({
      SecretId: ossConfig.SecretId,  // 改为首字母大写
      SecretKey: ossConfig.SecretKey, // 改为首字母大写
      SecurityToken: ossConfig.SecurityToken, // 改为首字母大写
      StartTime: ossConfig.StartTime, // 改为首字母大写
      ExpiredTime: ossConfig.ExpiredTime // 改为首字母大写
    })

    // 使用后端返回的Prefix作为目录前缀，如果不存在则使用传入的directory
    const prefix = ossConfig.Prefix || directory
    const fileName = `${prefix}${Date.now()}_${file.name}`

    cos.putObject({
      Bucket: ossConfig.Bucket, // 改为首字母大写
      Region: ossConfig.Region, // 改为首字母大写
      Key: fileName,
      Body: file,
      onProgress: (progressData) => {
        console.log('上传进度:', progressData)
      }
    }, (err, data) => {
      if (err) {
        reject(err)
      } else {
        // 返回文件的完整URL
        const fileUrl = `https://${data.Location}`
        resolve(fileUrl)
      }
    })
  })
}

// 分片上传到COS
export const chunkedUploadToCos = async (file, ossConfig, directory = 'work/', chunkSize = 5 * 1024 * 1024) => {
  return new Promise((resolve, reject) => {
    const COS = require('cos-js-sdk-v5')

    const cos = new COS({
      SecretId: ossConfig.SecretId,  // 改为首字母大写
      SecretKey: ossConfig.SecretKey, // 改为首字母大写
      SecurityToken: ossConfig.SecurityToken, // 改为首字母大写
      StartTime: ossConfig.StartTime, // 改为首字母大写
      ExpiredTime: ossConfig.ExpiredTime // 改为首字母大写
    })

    // 使用后端返回的Prefix作为目录前缀，如果不存在则使用传入的directory
    const prefix = ossConfig.Prefix || directory
    const fileName = `${prefix}${Date.now()}_${file.name}`

    cos.sliceUploadFile({
      Bucket: ossConfig.Bucket, // 改为首字母大写
      Region: ossConfig.Region, // 改为首字母大写
      Key: fileName,
      Body: file,
      SliceSize: chunkSize,
      onProgress: (progressData) => {
        console.log('分片上传进度:', progressData)
      }
    }, (err, data) => {
      if (err) {
        reject(err)
      } else {
        const fileUrl = `https://${data.Location}`
        resolve(fileUrl)
      }
    })
  })
}